import { ResponseActionsState } from "./types";

export function getDefaultState(): ResponseActionsState {
	return {
		responseActions: [],
		supportedActionTypes: [],
	};
}
